import { DateRangePickerDropdown } from '@winnin/ds-date-range-picker'

import type { TCustomDatePickerRangeViewProps } from './custom-date-picker-range.types'

/** Pure presentation: renders the DS dropdown with the props the model computed. */
export function CustomDatePickerRangeView(props: Readonly<TCustomDatePickerRangeViewProps>) {
  return <DateRangePickerDropdown {...props} />
}
